import { EAnalyticsFieldName, EFieldName } from '../constants';

export const mapFieldNameToAnalyticsFieldName: Record<EFieldName, EAnalyticsFieldName> = {
  [EFieldName.ObjectCost]: EAnalyticsFieldName.ObjectCost,
  [EFieldName.DownPayment]: EAnalyticsFieldName.DownPayment,
  [EFieldName.loanTermYears]: EAnalyticsFieldName.LoanTermYears,
  [EFieldName.lifeInsurance]: EAnalyticsFieldName.LifeInsurance,
  [EFieldName.benefitProgram]: EAnalyticsFieldName.BenefitProgram,
};
